import { render, staticRenderFns } from "./ReportSummaryHistory.vue?vue&type=template&id=a1ff974e&"
import script from "./ReportSummaryHistory.vue?vue&type=script&lang=js&"
export * from "./ReportSummaryHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports